import { render, staticRenderFns } from "./AuthAction.vue?vue&type=template&id=5918c9dc&"
import script from "./AuthAction.vue?vue&type=script&lang=ts&"
export * from "./AuthAction.vue?vue&type=script&lang=ts&"
import style0 from "./AuthAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports